import axios from 'axios'
import { Message } from 'element-ui'
// import { getToken } from '@/utils/auth'

import Cookies from 'js-cookie'


const service = axios.create({
  // baseURL: process.env.BASE_API
   baseURL: '/sxtucaihui',
  timeout: 10000,
    headers: { 'Content-Type': 'application/json',
    'userId':  Cookies.get('UserID')? Cookies.get('UserID')  : '',
    'orgGid':  Cookies.get('orgGid')? Cookies.get('orgGid')  : '',
    'token':  Cookies.get('token')? Cookies.get('token')  : '',
    'source':  Cookies.get('source')? Cookies.get('source')  : '',
    'datasource':  Cookies.get('logintype')? Cookies.get('logintype')  : '',
    'adminState':  Cookies.get('adminState')? Cookies.get('adminState')  : '',
 },
  withCredentials: true // 不允许携带cookie
})

service.interceptors.request.use(config => {
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

service.interceptors.response.use(response => {
  // console.log(response)
  if (response.data.code === '200') {
    return response.data
  } else {
    Message({
      message: response.data.msg,
      type: 'error',
      duration: 5 * 1000
    })
    return null
  }
}, error => {
  Message({
    message:"亲，服务器出小差啦，请稍后重试！",
    type: 'error',
    duration: 5 * 1000
  })
  return Promise.reject(error)
})

// 封装get请求
let getRequest = (url) => {
  return new Promise((reslove, reject) => {
    service.get(url).then(res => {
      reslove(res)
    }, (err) => {
      reject(err)
    })
  })
}

// 封装post请求()
let postRequest = (url, data) => {
  let Datas = data || {}; // 如果data为null或undefined，则设置为空对象
  if (Object.keys(Datas).length === 0) {
    Datas = { timestamp: new Date().getTime() }; // 当data为空对象时，直接添加timestamp属性
  } else {
    Datas.timestamp = new Date().getTime(); // 否则，在现有对象上添加timestamp属性
  }
  const secretKey = 'TwPp-a7AZ-Nk92-B1u';
  const paramString = Object.keys(Datas).filter(key => Datas[key] !== null && Datas[key] !== undefined && Datas[key] !== '' && Array.isArray(Datas[key])
    === false && typeof Datas[key] === 'object' === false).sort().map(key => `${key}=${Datas[key]}`).join('&');
  const signatures = CryptoJS.MD5(paramString + secretKey).toString();
  Datas.signature = signatures;
  return new Promise((resolve, reject) => {
    service.post(url, Datas).then(res => {
      resolve(res);
    }).catch(err => {
      reject(err);
    });
  });
}

// 封装put请求
let putRequest = (url, data) => {
  return new Promise((reslove, reject) => {
    service.put(url, data).then(res => {
      reslove(res)
    }, (err) => {
      reject(err)
    })
  })
}

// delete 请求
let deleteRequest = (url) => {
  return new Promise((reslove, reject) => {
    service.delete(url).then(res => {
      reslove(res)
    }, err => {
      reject(err)
    })
  })
}
export {
  service as request,
  getRequest,
  postRequest,
  putRequest,
  deleteRequest
}




// WEBPACK FOOTER //
// ./src/sealFilter/request.js